import React, { Fragment } from 'react'

import './styles.scss'

import backgroundImg from './img/background.jpg'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro251">
      <div className="intro251mobile screen">
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL">
            <div className="image-xUsx1L bp1-intro251-animate-enter">
              <div className="overlay-NrugUn"></div>
              <img src={background || backgroundImg} />
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="stacked-group-C61RwL">
            <div className="notranslate text-SHDHHB bp1-intro251-animate-enter1">
              {coupleSingleName.bride}{' '}
              {coupleSingleName.groom && (
                <Fragment>
                  e <br /> {coupleSingleName.groom}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="intro251desktop screen">
        <div className="mask-C61RwL"></div>
        <div className="container-center-horizontal">
          <div className="button-C61RwL">
            <div
              className="site-de-casamento-e-xHxYv9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-xHxYv9" onClick={onSkipIntro}>
              <div className="pular-introduo-kA8htT">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="content-C61RwL">
            <div className="image-xUsx1L bp2-intro251-animate-enter">
              <div className="overlay-NrugUn"></div>
              <img src={background || backgroundImg} />
            </div>
            <div className="stacked-group-xUsx1L">
              <div className="notranslate text-6En43k bp2-intro251-animate-enter1">
                {coupleSingleName.bride}{' '}
                {coupleSingleName.groom && (
                  <Fragment>
                    e <br /> {coupleSingleName.groom}
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
